export type TicketDetail = {
  id?: string;
  user_id?: string;
  userId?: string;
  user?: { id?: string };
  [key: string]: unknown;
};

export const getTicketDetailFromStorage = (): TicketDetail | null => {
  try {
    const stored = localStorage.getItem("ticket_detail");
    return stored ? (JSON.parse(stored) as TicketDetail) : null;
  } catch {
    return null;
  }
};

export const getUserIdFromTicket = (ticket: TicketDetail | null): string | null => {
  if (!ticket) return null;
  const id = ticket.user_id || ticket.userId || ticket.user?.id;
  return id ? String(id) : null;
};

export const getPaymentSubscriptionUserId = (): string | null => {
  const fromTicket = getUserIdFromTicket(getTicketDetailFromStorage());
  if (fromTicket) return fromTicket;

  return null;
};
